import { render, staticRenderFns } from "./AllContactbox.vue?vue&type=template&id=b530410e&"
import script from "./AllContactbox.vue?vue&type=script&lang=js&"
export * from "./AllContactbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports